import dorisService from '../service/doris';


const chainsAll_REQ = () => {
  return {
    type: 'CHAIN_ALL_REQ'
  };
};

const chainsAll_OK = chains => {
  return {
    type: 'CHAIN_ALL_OK',
    chains
  };
};

const chainsAll_X = () => {
  return {
    type: 'CHAIN_ALL_X'
  };
};

const siteAll_REQ = () => {
  return {
    type: 'SITE_ALL_REQ'
  };
};

const siteAll_OK = sites => {
  return {
    type: 'SITE_ALL_OK',
    sites
  };
};

const siteAll_X = () => {
  return {
    type: 'SITE_ALL_X'
  };
};

const profile_REQ = () => {
  return {
    type: 'PROFILE_REQ'
  };
};

const profile_OK = profile => {
  return {
    type: 'PROFILE_OK',
    profile
  };
};

const profile_X = () => {
  return {
    type: 'PROFILE_X'
  };
};

const setSelectedChain = chainId => {
  return {
    type: 'CHAIN_SELECTED_SET',
    selectedChain: chainId
  };
};

const setSelectedSite = siteId => {
  return {
    type: 'SITE_SELECTED_SET',
    selectedSite: siteId
  };
};

const fetchChains = async dispatch => {
  try {
    dispatch(chainsAll_REQ());
    const response = await dorisService.getChains();
    if (response.status !== 200) throw response.status;
    const chains = response.data;
    dispatch(chainsAll_OK(chains));
  } catch (error) {
    console.log(error);
    dispatch(chainsAll_X());
  }
};

const fetchSites = async (dispatch, chainId) => {
  try {
    dispatch(siteAll_REQ());
    const response = await dorisService.getSites(chainId);
    if (response.status !== 200) throw response.status;
    const sites = response.data;
    dispatch(siteAll_OK(sites));
  } catch (error) {
    dispatch(siteAll_X());
  }
};

const setLastSelectedSite = async (dispatch, profile) => {
  try {
    dispatch(profile_REQ());
    dispatch(profile_OK(profile));
    const { lastSiteId } = profile;
    dispatch(setSelectedSite(lastSiteId));
  } catch (error) {
    dispatch(profile_X());
  }
};

const setPreferredLanguage = async (dispatch, language) => {
  dispatch({
    type: 'PREFERRED_LANGUAGE_SET',
    language
  });
};

export {
  fetchChains,
  fetchSites,
  setSelectedChain,
  setSelectedSite,
  setLastSelectedSite,
  setPreferredLanguage
};